import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=1ab1662c&scoped=true&lang=pug&"
import script from "./CustomerData.vue?vue&type=script&lang=js&"
export * from "./CustomerData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=1ab1662c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab1662c",
  null
  
)

/* custom blocks */
import block0 from "./CustomerData.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports